import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";
import { FootballFieldState } from "./scenes/match-scene/FootballFieldState";
import { GameConstants } from "./GameConstants";
import { Ball } from "./physics/Ball";
import { PlayersManager } from "./physics/players/PlayersManager";

    export class MatchManager {

        public static currentInstance: MatchManager;

        private static game: Phaser.Game;

        public static init(game: Phaser.Game) {

            MatchManager.currentInstance = this;
            MatchManager.game = game;

            GameVars.isBallAttachedToPassingMidfielder = false;
            GameVars.isBallAttachedToShootingPlayer = false;

            var levelData: any = GameVars.getLevelData(GameVars.matchID - 1);

            GameVars.adversaryGoals = levelData[0].goals;
            GameVars.streakerFrequency = levelData[0].streakerFreq;

            GameVars.goalKeeperType = levelData[0].goalkeeperType;

            GameVars.playerGoals = 0;
            
            GameVars.ballsInField = 0;
            GameVars.voodooUsed = false;

            if (levelData[0].time > 0) {
                GameVars.time = levelData[0].time;
                GameVars.isTimedLevel = true;
                GameVars.balls = 100; // INFINITOS BALONES PARA LOS NIVELES DE TIEMPO
            } else {
                GameVars.isTimedLevel = false;
                GameVars.balls = levelData[0].balls;
            }

            GameVars.timeOver = false;
            GameVars.matchEnded = false;
            GameVars.isGoalKeeperDuck = false;

            GameVars.isBallAttachedToPlayer = false;

            GameVars.penalties = false;
            GameVars.paused = true;
            GameVars.penaltyScored = false;
        }

        public static onMatchStart(): void {

            GameManager.onMatchStart();
            
            FootballFieldState.currentInstance.onMatchStart();

            MatchManager.game.time.events.add( 150, function(): void {
                GameVars.paused  = false;
            }, MatchManager);
        }

        public static onClickInGameScene (): void {

            if ( GameVars.isShooterReady ) {
                MatchManager.kickOff();
            } else if ( GameVars.isBallAttachedToPassingMidfielder ) {
                GameVars.isBallAttachedToPassingMidfielder = false;
                MatchManager.passBall();
            } else if ( GameVars.isBallAttachedToShootingPlayer ) {
                GameVars.isBallAttachedToShootingPlayer = false;
                MatchManager.shootBall();
            }
        }

        public static onExtraBallStanding (): void {

            GameVars.ballsInField --;
            MatchManager.checkBalls(false);
        }

        public static onBallReturnedToStartingPoint (): void {

            GameVars.ballsInField = 0;
            GameVars.balls ++;
            FootballFieldState.currentInstance.onBallReturnedToStartingPoint();
        }

        public static onPause(): void {
            
            GameVars.paused  = true;
            FootballFieldState.currentInstance.pauseGame();
        }

        public static onResume(): void {
            
            GameVars.paused  = false;
            FootballFieldState.currentInstance.resumeGame();
        }

        public static onTimeUp(): void {

            // que los jugadores no puedan pillar pelotas
            GameVars.timeOver = true;

            if (GameVars.isBallAttachedToPlayer || FootballFieldState.currentInstance.ballsManager.shooterMoving || GameVars.isShooterReady) {
                MatchManager.onMatchEnd();
            }
        }

        public static onGoal(): void {

            GameVars.playerGoals++;
            GameVars.ballsInField--;

            FootballFieldState.currentInstance.onGoal();

            MatchManager.checkBalls(true);
        }

        public static onBallOutsideFootballField(): void {

            GameVars.ballsInField --;
            MatchManager.checkBalls(false);
        }

        public static onStreakerEntry (): void {

            FootballFieldState.currentInstance.onStreakerEntry();
        }

        public static onStreakerHit (): void {
            
            // dar 3 balones extra
            GameVars.balls += 3;
            FootballFieldState.currentInstance.onStreakerHit();
        }

        // POWER UPS
        public static onPowerUpFreezeGoalkeeperSelected(): void {

            GameManager.onPowerUpUsed(GameConstants.FREEZE_GOALKEEPER);

            FootballFieldState.currentInstance.onPowerUpFreezeGoalkeeperSelected();
        }

        public static onPowerUpExtraBallsSelected(): void {

            GameManager.onPowerUpUsed(GameConstants.EXTRA_BALLS);

            // dar 3 balones extra
            GameVars.balls += 3;

            MatchManager.game.time.events.add(300, function(): void {
                FootballFieldState.currentInstance.onPowerUpExtraBallsSelected();
            }, this);
        }

        public static onPowerUpBallOfFireSelected(): void {

            GameManager.onPowerUpUsed( GameConstants.BALL_OF_FIRE );

            FootballFieldState.currentInstance.onPowerUpBallOfFireSelected();
        }

        public static onPowerUpVoodooSelected(): void {

            GameManager.onPowerUpUsed( GameConstants.VOODOO );

            GameVars.voodooUsed = true;

            MatchManager.game.time.events.add(300, function(): void {
                FootballFieldState.currentInstance.onPowerUpVoodooSelected();
            }, this);
        }

        public static onBallAttachedToPlayer (player: any, ball: Ball): void {

            GameVars.isBallAttachedToPlayer = true;

            if ( player.name === GameConstants.MIDFIELDER_PEG ) {
                GameVars.isBallAttachedToPassingMidfielder = true;
                PlayersManager.currentInstance.onBallAttachedToMidfielder(player, ball);
            } else {
                GameVars.isBallAttachedToShootingPlayer = true;
                PlayersManager.currentInstance.onBallAttachedToForward(player, ball);
            }
        }

        public static onPlayerReadyToShoot (): void {

            GameVars.isBallAttachedToShootingPlayer = true;
        }

        public static onExtraBall (x: number, y: number, isBallOfFire: boolean): void {

            GameVars.ballsInField++;
            FootballFieldState.currentInstance.onExtraBall( x, y, isBallOfFire );
        }

        public static onMagicPotion(): void {

            GameVars.isGoalKeeperDuck = true;
            FootballFieldState.currentInstance.onMagicPotion();
        }

        private static kickOff(): void {

            GameVars.ballsInField = 1;
            GameVars.balls = GameVars.balls > 0 ? GameVars.balls - 1 : 0;

            FootballFieldState.currentInstance.kickOff();
        }

        private static checkBalls( goalScored: boolean): void {

            if ( GameVars.ballsInField === 0) { 

                // mirar si quedan chutes disponibles
                if (GameVars.balls === 0 || GameVars.timeOver) {
                    MatchManager.onMatchEnd();
                } else {
                    FootballFieldState.currentInstance.onNoBallsInTheField(goalScored);
                }
            }
        }

        private static passBall(): void {

            PlayersManager.currentInstance.passBall();
        }

        private static shootBall(): void {

            GameVars.isBallAttachedToPlayer = false;

            const receivingPlayer = PlayersManager.currentInstance.receivingPlayer;

            // se tiene en cuenta la rotacion del jugador
            const angle  = receivingPlayer.getShootAngle();
            const ball_px = receivingPlayer.x + 75 * Math.cos( angle * Math.PI / 180 );
            const ball_py = receivingPlayer.y + 75 * Math.sin( angle * Math.PI / 180 );
            const powerKick = receivingPlayer.name ===  GameConstants.FORWARD_PEG ? true : false;
            const isBallOfFire = receivingPlayer.ball.ballOnFire;
            const isExtraBall = receivingPlayer.ball.isExtraBall;

            FootballFieldState.currentInstance.shootBall(ball_px , ball_py , angle, powerKick, isBallOfFire, isExtraBall);
            PlayersManager.currentInstance.shootBall();
        }

        private static onMatchEnd(): void {

            if (GameVars.matchEnded) {
                return;
            }

            GameVars.matchEnded = true;

            if (GameVars.playerGoals > GameVars.adversaryGoals) {

                GameVars.matchResult = GameConstants.VICTORY;

            } else if ( GameVars.playerGoals < GameVars.adversaryGoals) {

                GameVars.matchResult = GameConstants.DEFEAT;
                
            } else {

                GameVars.matchResult = GameConstants.DRAW;
            }

            GameManager.onMatchEnded();
        }
    }
